import React from "react";
import {
  TextField,
  Button,
  Dialog,
  Slide,
  InputAdornment,
  Snackbar,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
// import { useHistory } from "react-router-dom";
import { payByWallet } from "../../../../SearchPage/_redux/searchCrud";
import config from "../../../../../../config/config";
import * as Scroll from "react-scroll";
import { AccountBalanceWallet, AttachMoney, Payment } from "@material-ui/icons";
import { getUserCredit } from "../../../../profile/CrudAndRedux/ProfileCrud";
import { getTicketDiscount, cancelTiket } from "./cruds";
import { actions } from "../../../../SearchPage/_redux/searchRedux";
import { toast } from "react-toastify";
import ReactLoading from "react-loading";
import queryStringParse from "../../../../../../functions/queryParam";
import UpdateReserve from "./UpdateReserve"
import { result } from "lodash";
import behPardakht from "../assets/behPardakht.png"
import asanPardakht from "../assets/asanPardakht.png"
import boite from "../assets/boite.png"

export const PAY_BY_GATEAWAY = config.baseUrl + "pay/mellat/";
export const PAY_BY_ASAN_PARDAKHT = config.baseUrl + "pay/asanPay/";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ReserveSecondStep = (props) => {
  const { state } = useSelector((state) => ({
    state: state.search,
  }));

  const { user } = useSelector((state) => state.auth)
  console.log("user", user)
  const userId = user.user.id

  const [width, setWidth] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [amount, setAmount] = React.useState(null);
  const [isAmountLoaded, setIsAmountLoaded] = React.useState(null);
  const [isAmountAvailable, setIsAmountAvailable] = React.useState(false);
  const [discountCode, setDiscountCode] = React.useState(null);
  const [alertMessage, setAlertMessage] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectGateway, setSelectGateway] = React.useState(false);
  const [discountedPricee, setDiscountedPricee] = React.useState(null);
  const [timer, setTimer] = React.useState('00:00:00');

  const Ref = React.useRef(null);

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const history1 = useHistory();
  const passengersCount = history1.location.pathname.split("/")[6].split(",");

  var scroll = Scroll.animateScroll;

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return {
      total, hours, minutes, seconds
    };
  }


  const startTimer = (e) => {
    let { total, hours, minutes, seconds }
      = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (hours > 9 ? hours : '0' + hours) + ':' +
        (minutes > 9 ? minutes : '0' + minutes) + ':'
        + (seconds > 9 ? seconds : '0' + seconds)
      )
    }
  }

  const clearTimer = (e) => {

    setTimer('00:05:00');
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000)
    Ref.current = id;
  }

  const getDeadTime = () => {
    let deadline = new Date();

    deadline.setSeconds(deadline.getSeconds() + 300);
    return deadline;
  }

  React.useEffect(() => {
    // getUserCredit(authState.user.token)
    //   .then((res) => {
    //     if (res.data.credit === null) {
    //       setAmount(0);
    //     } else {
    //       setAmount(res.data.credit);
    //     }
    //     setIsAmountLoaded(true);
    //   })
    //   .catch(() => {
    //     setIsAmountLoaded(false);
    //   });
    scroll.scrollToTop();
  }, []);

  React.useEffect(() => {
    clearTimer(getDeadTime());
  }, [])

  // const timeManager = (time) => {
  //   if (time) {
  //     const splittedTime = time
  //       .split("T")[1]
  //       .split(".")[0]
  //       .split(":");
  //     return `${splittedTime[0]}:${splittedTime[1]}`;
  //   }
  // };


  const persianDateHandler = () => {
    let params = [];


    if (history.location.search) {
      var search = history.location.search;
      params = queryStringParse(search);

    }
    const urlDate = history.location.pathname.split("/")[4];
    let dateOptions = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const persianDate = new Date(urlDate).toLocaleDateString(
      "fa-Ir",
      dateOptions
    );

    const day = persianDate.split(",")[1];
    const monthAnddate = persianDate.split(",")[0].split(" ");

    const mixed = `${day}, ${monthAnddate[2]} ${monthAnddate[1]}`;

    return mixed;
  };

  const urlDateHandler = () => {
    let params = [];
    if (history.location.search) {
      var search = history.location.search;
      params = queryStringParse(search);

    }
    const urlDate = history.location.pathname.split("/")[4];

    return urlDate;
  };

  const cancel_tiket = () => {
    const ticketId = state?.ticketInvoice?.ticketId;
    const token = authState.user.token;
    const data = { ticketId }
    cancelTiket(data, token)
      .then((res) => {
        console.log("cancel: ", res.message)
      })
      .catch((err) => { console.log(err) });
  }

  // let params = [];

  // let dates;
  // if (props.location.search) {
  //   var search = props.location.search;
  //   params = queryStringParse(search);

  // }
  // if (params.date && !dates) {
  //   dates = params.date.split(",");
  // }
  const history = useHistory();
  console.log("10", history.location.key)

  // React.useEffect(() => {


  //   if (!params.date && !params.count) {
  //     let today = new Date();
  //     today.setDate(today.getDate() + 1);
  //     const splittedDate = today.toLocaleDateString().split("/");
  //     const datez = `${splittedDate[2]}-${splittedDate[0]}-${splittedDate[1]}`;

  //     history.push(
  //       `/bus-ticket/${props.match.params.source_id}/${props.match.params.dest_id}?date=${datez}&count=1,0`
  //     );
  //   }
  // }, []);

  return (
    <>
      <div
        style={{ border: "1px solid darkgray", borderRadius: 13 }}
        className="d-flex bg-white shadow-sm my-5 d-flex flex-column p-5 container"
      >
        <div className=" p-2 text-dark">
          <div className="row d-flex justify-content-between">
            <div className="col-md-3 col-5 px-0 d-flex justify-content-center align-items-center">
              <h2 className="mb-0">
                <b>مشخصات بلیط</b>
              </h2>
            </div>
            <div className="col-md-4 col-lg-3 col-7 row d-flex justify-content-left">
              <b
                className="col-md-6 col-6 px-0 d-flex justify-content-center align-items-center"
                style={{ fontSize: "15px" }}
              >زمان باقی مانده: </b>
              <Button
                className="btn w-100 col-md-5 col-6"
                style={{
                  backgroundColor: "#6dd06d",
                  height: "3.2em",
                  fontSize: 16,
                  borderRadius: 13,
                }}
              >

                <b
                  style={{
                    fontSize: 21
                  }}
                >{timer}</b>
              </Button>
            </div>
          </div>
          {/* <h6
            className="mb-3 mt-10"
            style={{ opacity: "0.9", lineHeight: "25px" }}
          >
            اطلاعات وارد شده را کنترل کرده و پس از اطمینان از درستی آنها برای
            پرداخت اقدام فرمایید
          </h6> */}
        </div>
        <div
          className="my-5 d-flex flex-column"
          style={{ border: "1px solid lightgray" }}
        >
          <div
            className="d-flex justify-content-between py-5 px-10"
            style={{
              border: "1px solid lightgray",
              backgroundColor: "lightgray",
            }}
          >
            <h6>مبدا:</h6>
            <h6>
              ترمینال {state.travelDetails.townshipsInfo.sourceTownshipTitle}
            </h6>
          </div>
          <div
            className="d-flex justify-content-between py-5 px-10"
            style={{ border: "1px solid lightgray" }}
          >
            <h6>مقصد:</h6>
            <h6>
              ترمینال {state.travelDetails.townshipsInfo.destTownshipTitle}
            </h6>
          </div>
          <div
            className="d-flex justify-content-between py-5 px-10"
            style={{
              border: "1px solid lightgray",
              backgroundColor: "lightgray",
            }}
          >
            <h6>تاریخ و ساعت حرکت:</h6>
            <h6>{persianDateHandler()}</h6>
          </div>
          <div
            className="d-flex justify-content-between py-5 px-10"
            style={{ border: "1px solid lightgray" }}
          >
            <h6>نام مسافر/مسافرین:</h6>
            <h6>
              <span style={{ fontSize: 15 }}>
                {/* بزرگسال: {+passengersCount[0]}
                <br />
                {+passengersCount[1] !== 0
                  ? `کودک: ${passengersCount[1]}`
                  : null} */}
                {state?.fullSeats ?
                  state.fullSeats.map((name, idx) => {
                    if (idx === state.fullSeats.length - 1) {
                      return `${name.passengerFirstName} ${name.passengerLastName}  `;
                    } else {
                      return `${name.passengerFirstName} ${name.passengerLastName}, `;
                    }
                  })
                  : null}
              </span>
            </h6>
          </div>
          <div
            className="d-flex justify-content-between py-5 px-10"
            style={{
              border: "1px solid lightgray",
              backgroundColor: "lightgray",
            }}
          >
            <h6> کدملی:</h6>
            <h6>
              {state.fullSeats.length !== 0
                ? state.fullSeats.map((el, idx) => {
                  if (idx === state.fullSeats.length - 1) {
                    return `${el.passengerNationalCode}  `;
                  } else {
                    return `${el.passengerNationalCode}, `;
                  }
                })
                : null}
            </h6>
          </div>

          <div
            className="d-flex justify-content-between py-5 px-10"

          >
            <h6>شماره صندلی:</h6>
            <h6>
              {state.fullSeats.length !== 0
                ? state.fullSeats.map((el, idx) => {
                  if (idx === state.fullSeats.length - 1) {
                    return `${el.seatNumber}  `;
                  } else {
                    return `${el.seatNumber}, `;
                  }
                })
                : null}
            </h6>
          </div>

          {/* <div className="d-block d-md-flex" style={{ alignItems: "baseline" }}>
            <h6>تاریخ و ساعت حرکت:</h6>
            <p className="mx-3" style={{ fontSize: "15px" }}>
              {persianDateHandler()} - ساعت{" "}
              {timeManager(state.travelDetails.directionInfo.departureDatetime)}
            </p>
          </div>
          <div
            className="line w-100 my-3"
            style={{ marginBottom: "auto" }}
          ></div>
          <div className="flex flex-column">
            <h6 className="my-5 d-flex align-items-center">
              مبدا:
              <span className="mx-4" style={{ fontSize: 15 }}>
                ترمینال {state.travelDetails.townshipsInfo.sourceTownshipTitle}{" "}
                {timeManager(
                  state.travelDetails.directionInfo.departureDatetime
                )}
              </span>
            </h6>
            <h6 className="my-5 d-flex align-items-center">
              مقصد:
              <span className="mx-4" style={{ fontSize: 15 }}>
                ترمینال {state.travelDetails.townshipsInfo.destTownshipTitle}{" "}
                {timeManager(state.travelDetails.arrivedTime)}
              </span>
            </h6>
          </div>
          <div
            className="line w-100 my-3"
            style={{ marginBottom: "auto" }}
          ></div>
          <h6 className="my-5 d-flex align-items-center">
            مسافر:
            <span className="mx-4" style={{ fontSize: 15 }}>
              بزرگسال: {+passengersCount[0]}
              <br />
              {+passengersCount[1] !== 0 ? `کودک: ${passengersCount[1]}` : null}
            </span>
          </h6>
          <div
            className="line w-100 my-3"
            style={{ marginBottom: "auto" }}
          ></div>
          <div className="d-block d-md-flex align-items-center my-4">
            <h6>شماره صندلی:</h6>
            <p className="mx-3" style={{ fontSize: "15px" }}>
              {state.fullSeats.length !== 0
                ? state.fullSeats.map((el, idx) => {
                    if (idx === state.fullSeats.length - 1) {
                      return `${el.seatNumber}  `;
                    } else {
                      return `${el.seatNumber}, `;
                    }
                  })
                : null}
            </p>
          </div> */}
        </div>
      </div>
      <div
        className="d-flex bg-white shadow-sm my-5 d-flex flex-column p-7 container"
        style={{ border: "1px solid darkgray", borderRadius: 13 }}
      >
        <h2 className="mt-3 mb-7">
          <b>فاکتور نهایی</b>
        </h2>
        <div className="py-5">
          <div
            className="d-flex justify-content-between align-items-center
      "
          >
            <h3
              className="mx-1"
              style={{ opacity: "0.85", whiteSpace: "nowrap" }}
            >
              بلیط (
              {parseFloat(passengersCount[0]) + parseFloat(passengersCount[1])}{" "}
              نفر)
            </h3>
            <div className="line w-100" style={{ marginBottom: "auto" }}></div>
            <h3 className="mx-1" style={{ opacity: "0.85" }}>
              {state.totalPrice.toLocaleString('ar-EG')}
              ریال
            </h3>
          </div>

          <div
            className="d-flex justify-content-between align-items-center my-5 p-5 text-white "
            style={{ backgroundColor: "darkgray", borderRadius: 13 }}
          >
            <h3 className="mx-1 my-auto text-white" style={{ opacity: "0.85" }}>
              <b>جمع کل</b>
            </h3>
            <h3 className="text-white mx-1 my-auto" style={{ opacity: "0.85" }}>
              <b>{(state.extraWeight * 780000 + state.totalPrice).toLocaleString('ar-EG')}</b>
              ریال
            </h3>
          </div>
        </div>
      </div>
      <div
        className="d-block d-md-flex bg-white  shadow-sm my-5 p-5 align-items-center container"
        style={{
          height: "auto",
          border: "1px solid darkgray",
          borderRadius: 13,
        }}
      >
        <div className="col-sm-12 col-md-9">
          <h6 style={{ lineHeight: "25px", marginBottom: "1.75rem" }}>
            آیا کد تخفیف دارید؟
          </h6>
        </div>
        <div className="col-sm-12 col-md-3 d-flex flex-column my-3 justify-content-center align-items-center">
          <TextField
            id="outlined-basic"
            // label="کد تخفیف"
            variant="outlined"
            style={{ width: "20rem" }}
            value={discountCode}
            onChange={(e) => {
              setDiscountCode(e.target.value);
            }}
            InputProps={{
              dir: "ltr",
              startAdornment: (
                <InputAdornment position="start">
                  <Button
                    className="d-flex align-items-center h-100 justify-content-center  bg-warning"
                    style={{
                      borderRadius: "17px",
                      position: "absolute",
                      left: "0",
                      bottom: "0",
                    }}
                    onClick={() => {
                      const data = {
                        ticketId: state.ticketInvoice.ticketId,
                        orderId: state.ticketInvoice.orderId,
                        discountCode,
                      };
                      setIsLoading(true);

                      getTicketDiscount(data, authState.user.token)
                        .then((res) => {
                          setDiscountedPricee(res.data.discountedPrice);
                          setAlertMessage({
                            message: "کد تخفیف با موفقیت اعمال شد",
                            type: "success",
                          });
                          setIsLoading(false);
                        })
                        .catch((err) => {
                          setIsLoading(false);

                          if (
                            err.response.data.message ===
                            "DiscountCode is not valid"
                          ) {
                            setAlertMessage({
                              message: "کد تخفیف وارد شده نادرست است",
                              type: "failed",
                            });
                          } else {
                            setAlertMessage({
                              message: "مشکلی در ارتباط با سرور بوجود آمد",
                              type: "failed",
                            });
                          }
                        });
                    }}
                  >
                    <h6
                      style={{ borderRadius: "13px" }}
                      className="mx-auto my-auto text-white"
                    >
                      {isLoading ? (
                        <ReactLoading
                          type={"spin"}
                          color={"white"}
                          height={"100%"}
                          width={"2rem"}
                        />
                      ) : (
                        "اعمال"
                      )}
                    </h6>
                  </Button>
                </InputAdornment>
              ),
              style: { direction: "ltr" },
            }}
          />
          <div
            className="mt-2 font-16 mx-auto"
            style={{
              color: alertMessage?.type == "failed" ? "red" : "#6dd06d",
            }}
          >
            {alertMessage?.message}
          </div>
        </div>
      </div>
      <div
        className="d-block d-md-flex bg-white  shadow-sm my-5 p-5 align-items-center container"
        style={{
          height: "auto",
          border: "1px solid darkgray",
          borderRadius: "13px",
        }}
      >
        <div className="col-sm-12 col-md-9">
          <ul>
            {/* <li style={{ fontSize: 15 }} className="my-3">
              لطفا توجه فرمایید که صندلی پس از گذشت ۱۵ دقیقه از رزرو درآمده و لازم است مجدد فرایند خرید را از سر بگیرید.
            </li> */}
            {/* <li style={{ fontSize: 15 }} className="my-3">
              با کلیک روی پرداخت به درگاه بانک منتقل خواهید شد.
            </li> */}
            <div style={{ fontSize: 15 }} className="my-3">
              <img src={boite} alt="gift" className="m-4" style={{ width: "35px" }} />
              <b>پیشنهاد ایباس</b>
              <p> 10% تخفیف خرید بلیط آنلاین در سفر بعدی شما:
                <br></br>
                کد تخفیف 
                 <b>off10</b>
              </p>
            </div>
          </ul>
        </div>
        <div className="col-sm-12 col-md-3 d-block align-items-center text-seccess">
          <h6
            className="text-center"
            style={{ marginBottom: "1rem" }}
          >
            {discountedPricee ? (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ gap: "17px" }}
              >
                <del style={{ fontSize: "18px" }}>
                  <span className="text-dark"> {state.totalPrice.toLocaleString('ar-EG')} ریال </span>
                </del>
                <div style={{ fontSize: "16px" }}>
                  {discountedPricee.toLocaleString('ar-EG')} <span className="text-dark">ریال </span>
                </div>
              </div>
            ) : (
              <>
                {state.totalPrice.toLocaleString('ar-EG')} <span className="text-dark">ریال </span>
              </>
            )}
          </h6>

          <div className="d-flex w-100" style={{ marginBottom: "1rem" }}>
            {
              userId === 265 ?
                <>
                  {!selectGateway ?
                    <>


                      {/* <Button
                        className={` align-items-center ${!width ? "d-none" : "d-flex"
                          } justify-content-center  `}
                        style={{
                          height: "4rem",
                          backgroundColor: "#6dd06d",
                          width: width ? "100%" : "50%",
                          borderRadius: "13px",
                        }}
                        onClick={() => {
                          const wholePrice = state.extraWeight * 10000 + state.totalPrice;
                          if (isAmountLoaded && amount - wholePrice > 0) {
                            setIsAmountAvailable(true);
                          }
                          setWidth(!width);
                          // props.handleComplete();
                        }}
                      >
                        <h6 className="text-white mx-auto my-auto">پرداخت</h6>
                      </Button> */}
                      <Button
                        className={`d-flex align-items-center justify-content-center`}
                        style={{
                          height: "4rem",
                          backgroundColor: "#6dd06d",
                          width: "100%",
                          borderRadius: "13px",
                          gap: "5px",
                        }}
                        onClick={() => {
                          // localStorage.setItem(
                          //   "orderID",
                          //   state.ticketInvoice.orderId
                          // );
                          // window.location =
                          //   PAY_BY_GATEAWAY + state.ticketInvoice.orderId;

                          setSelectGateway(true)

                          // if(timer == "00:00:00"){

                          // }
                          // payByGateaway(state.ticketInvoice.orderId).then((res) => {
                          //   // window.open(res.config.url, "_blank");
                          //   // window.location=res.config.url;
                          //   props.handleComplete();
                          // });
                        }}
                      >
                        <Payment
                          style={{
                            fontSize: "25px",
                          }}
                          className="text-white"
                        />
                        <h6 className="mx-auto my-auto text-white">پرداخت</h6>
                      </Button>
                      <Button
                        className={` align-items-center ml-3 ${!width ? "d-none" : "d-flex"
                          } justify-content-center  `}
                        style={{
                          height: "4rem",
                          backgroundColor: "#ddd",
                          width: width ? "100%" : "50%",
                          borderRadius: "13px",
                          marginLeft: "5px"
                        }}
                        onClick={() => {
                          // کنسل کردن بلیط و خروج از رزرو
                          cancel_tiket();
                          window.location.reload();
                        }}
                      >
                        <h6 className="text-white mx-auto my-auto">لغو خرید</h6>
                      </Button>
                    </>
                    : null}
                  {selectGateway ?
                    <>
                      <div
                        className="d-block d-md-flex bg-white shadow-sm p-4 align-items-center container row"
                        style={{
                          height: "auto",
                          border: "1px solid darkgray",
                          borderRadius: "13px",
                          justifyContent: "center"
                        }}
                      >
                        <div className="col-12 mb-4" style={{ fontWeight: "bold" }}>انتخاب درگاه</div>
                        <div className="col-12 row">
                          <img
                            onClick={() => {
                              localStorage.setItem(
                                "orderID",
                                state.ticketInvoice.orderId
                              );
                              window.location =
                                PAY_BY_ASAN_PARDAKHT + state.ticketInvoice.orderId;

                            }}
                            src={asanPardakht}
                            alt="asanPardakht logo"
                            style={{ width: "80px", cursor: "pointer" }}
                            className="col-6 px-2" />
                          <img
                            onClick={() => {
                              localStorage.setItem(
                                "orderID",
                                state.ticketInvoice.orderId
                              );
                              window.location =
                                PAY_BY_GATEAWAY + state.ticketInvoice.orderId;

                            }}
                            src={behPardakht}
                            alt="behPardakht logo"
                            style={{ width: "80px", cursor: "pointer" }}
                            className="col-6 px-2" />
                        </div>
                      </div>
                    </>
                    : null}
                </>
                :
                <>
                  <Button
                    className={`d-flex align-items-center justify-content-center`}
                    style={{
                      height: "4rem",
                      backgroundColor: "#6dd06d",
                      width: "100%",
                      borderRadius: "13px",
                      gap: "5px",
                    }}
                    onClick={() => {
                      localStorage.setItem(
                        "orderID",
                        state.ticketInvoice.orderId
                      );
                      window.location =
                        PAY_BY_GATEAWAY + state.ticketInvoice.orderId;

                    }}
                  >
                    <Payment
                      style={{
                        fontSize: "25px",
                      }}
                      className="text-white"
                    />
                    <h6 className="mx-auto my-auto text-white">پرداخت</h6>
                  </Button>
                  <Button
                    className={` align-items-center ${!width ? "d-none" : "d-flex"
                      } justify-content-center  `}
                    style={{
                      height: "4rem",
                      backgroundColor: "#ddd",
                      width: width ? "100%" : "50%",
                      borderRadius: "13px",
                      marginLeft: "5px"
                    }}
                    onClick={() => {
                      // کنسل کردن بلیط و خروج از رزرو
                      cancel_tiket();
                      window.location.reload();
                    }}
                  >
                    <h6 className="text-white mx-auto my-auto">لغو خرید</h6>
                  </Button>
                </>
            }
            {/* {!width ? (
              <div
                className="d-flex mt-2 w-100"
                style={{ gap: 5, marginRight: 5 }}
              >
                <div
                  className="p-0 w-50"
                  style={{
                    cursor: isAmountAvailable ? "pointer" : "not-allowed",
                  }}
                >
                  {/* <Button
                    className={`d-flex align-items-center justify-content-center  w-100`}
                    style={{
                      height: "3.5rem",
                      backgroundColor: "#6dd06d",
                      borderRadius: "13px",
                      padding: 10,
                      gap: "5px",
                    }}
                    disabled={isAmountAvailable ? false : true}
                    onClick={() => {
                      const data = {
                        travelTicketId: state.ticketInvoice.ticketId,
                        orderId: state.ticketInvoice.orderId,
                      };
                      // setWidth(!width);
                      payByWallet(data, authState.user.token)
                        .then((res) => {
                          props.handleComplete();
                        })
                        .catch((err) => {
                          if (
                            err.response.data.message === "Credit is not enough"
                          ) {
                            setOpen(true);
                          }
                        });
                    }}
                  >
                    <AccountBalanceWallet
                      style={{ fontSize: "25px" }}
                      className="text-white"
                    />

                    <h6 className="mx-auto my-auto text-white">کیف پول</h6>
                  </Button> 
                </div>
                <Button
                  className={`d-flex align-items-center justify-content-center`}
                  style={{
                    height: "3.5rem",
                    backgroundColor: "#6dd06d",
                    width: "50%",
                    borderRadius: "13px",
                    gap: "5px",
                  }}
                  onClick={() => {
                    // setWidth(!width);
                    localStorage.setItem(
                      "orderID",
                      state.ticketInvoice.orderId
                    );
                    window.location =
                      PAY_BY_GATEAWAY + state.ticketInvoice.orderId;
                    // if(timer == "00:00:00"){

                    // }
                    // payByGateaway(state.ticketInvoice.orderId).then((res) => {
                    //   // window.open(res.config.url, "_blank");
                    //   // window.location=res.config.url;
                    //   props.handleComplete();
                    // });
                  }}
                >
                  <Payment
                    style={{
                      fontSize: "25px",
                    }}
                    className="text-white"
                  />
                  <h6 className="mx-auto my-auto text-white">پرداخت</h6>
                </Button>
              </div>
            ) : null} */}

          </div>
          {/* <h6 className="text-dark" style={{ marginBlock: "1rem" }}>
            {amount || amount === 0 ? (
              <div style={{ fontSize: "16px" }}>
                موجودی حساب شما :
                <span style={{ color: "#6dd06d" }}>{amount.toLocaleString('ar-EG')}</span> ریال
              </div>
            ) : null}
          </h6> */}




        </div>
      </div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        PaperProps={{
          style: { minWidth: "35%", minHeight: "37rem", maxHeight: "unset" },
        }}
        className="p-10"
        disableBackdropClick
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="row container mx-auto p-4">
          <div className="col-12 d-flex justify-content-center">
            <AttachMoney
              className="col-6"
              style={{
                fontSize: "10rem",
                color: "#6dd06d",
                transform: "rotate(90deg)",
              }}
            />
          </div>
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ gap: 10 }}
          >
            {/* <h1 className="text-danger">
              {" "}
              <b>موجودی کیف پول شما کافی نمیباشد !!!</b>
            </h1> */}
            <div className="row container">
              <div
                className="col-12 my-2 col-md-6 p-1"
                style={{ height: "4rem" }}
              >
                <Button
                  className="w-100 h-100"
                  style={{
                    backgroundColor: "#6dd06d",
                    border: "0.5px solid white",
                    borderRadius: "13px",
                  }}
                  onClick={() => {
                    window.location =
                      PAY_BY_GATEAWAY + state.ticketInvoice.orderId;
                  }}
                >
                  <h6 className="mx-auto my-auto text-white">پرداخت آنلاین</h6>
                </Button>
              </div>
              <div
                className="col-12 my-2 col-md-6 p-1"
                style={{ height: "4rem" }}
              >
                {/* <Button
                  className="w-100 h-100 "
                  style={{
                    border: "0.5px solid #6dd06d",

                    borderRadius: "13px",
                  }}
                  onClick={() => {
                    history.push("/account/recharge");
                  }}
                >
                  <h6 className="mx-auto my-auto" style={{ color: "#6dd06d" }}>
                    شارژ کیف پول
                  </h6>
                </Button> */}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {timer === "00:00:00" ? (
        <UpdateReserve
          date={state.props.date}
          count={passengersCount}
          travelId={state.props.travelId}
          //  date={dates ? dates[0] : null}
          // date2={!dates ? null : dates[1]}
          source_id={state.travelDetails.townshipsInfo.sourceTownshipTitle}
          dest_id={state.travelDetails.townshipsInfo.destTownshipTitle}
        />
      ) : null}
    </>
  );
};

export default ReserveSecondStep;
